import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/opportunity/:id',
    name: 'Opportunity',
    component: () => import('../views/OpportunityView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/opportunity/NotFound'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router